const activeToasts = ref<Toast[]>([]);

export function useToast() {
  const addToast = (toast: Toast) => {
    activeToasts.value.push(toast);
  };

  const removeToast = (id: string | number) => {
    activeToasts.value = activeToasts.value.filter((t) => t.id !== id);
  };
  return { activeToasts, addToast, removeToast };
}
